<!--硬件产品-->
<template>
  <div>
    <fy_header></fy_header>
    <fy_banner></fy_banner>
    <!--    <fy_container v-for="(item,index) in containerList" :key="index" :container="item"></fy_container>-->
    <fy_tabbar :title="title" :product-list="productList"
               :extend="hardExtend" :show_grid="true"  v-on:clickTab="clickTab"></fy_tabbar>
    <fy_footer></fy_footer>
  </div>
</template>

<script>
    import fy_header from "../components/fy_header"
    import fy_banner from "../components/fy_banner"
    import fy_tabbar from "../components/fy_tabbar"
    import fy_footer from "../components/fy_footer"

    import productList from "../assets/conf/hardware"
    import hardExtend from "../assets/conf/hard_extend"
    import click from "../js/clickTab"

    export default {
        name: "hardware",
        components: {
            fy_header,
            fy_banner,
            fy_tabbar,
            fy_footer,
        },
        data() {
            return {
                title: ['云播报', '云打印', '其他设备'],
                productList,
                hardExtend,
            }
        },
        mounted() {
            let index = parseInt(this.$cookies.get('hardwareTitle') || 0)
            click(index)
        },
        methods: {
            clickTab(index) {
                console.log('硬件监听到' + index)
                this.$cookies.set('hardwareTitle',index,'1d','/')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/hardware.vue